import { _, Component, Container, React } from "utils";
import { Loading } from "components";
import { App, Creators, FairStore, JobStore } from "model";
import { withRouter } from "react-router-dom";
import "./jobdetails.less";
import "./jobdetails-rs.less";

class JobDetails extends Component {
  static getStores() {
    return [JobStore, FairStore];
  }

  static calculateState() {
    let fairData = FairStore.getFairData();
    let isFairActive = fairData
      ? fairData.active
        ? fairData.active
        : false
      : false;

    return {
      fairId: FairStore.getFairId(),
      fairDomain: FairStore.getFairDomain(),
      details: JobStore.getDetails(),
      isFairActive,
    };
  }

  componentDidMount() {
    var { jobId } = this.props.match.params;
    Creators.loadDetails(jobId);
  }

  getCookie = (cname) => {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");

    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  };

  handleApply = (event) => {
    // event.preventDefault();

    var { details } = this.state;
    // var { history } = this.props;

    var offerCategory = "";

    if (details.offerCategory) {
      offerCategory = details.offerCategory.name;
    }

    var stand = details.stand.title;
    var category = `/${offerCategory}/stand/${stand}`;
    var label = details.id + "";

    ga("send", {
      hitType: "event",
      eventCategory: category,
      eventAction: "apply",
      eventLabel: label,
    });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "apply",
    });
  };

  //TODO: responsive slider hack
  componentDidUpdate() {
    let responsiveIds = [
      "responsive_galery",
      "responsive_galery1",
      "responsive_galery2",
    ];
    responsiveIds.forEach((name, i) => {
      let timeout = 4000 + i * 1000;
      $("#" + name + "").responsiveSlides({ timeout });
    });
  }

  render() {
	var { details, isFairActive, fairId, fairDomain } = this.state;
    var applyLink = null;
    var view = null;

    /** :( */
	let specialGreenName = fairDomain === 'rs.regionalnisajamposlova.com';
	let specialGreenId = [21, 38, 45, 51, 65, 71].includes(fairId);
	let specialGreenTheme = specialGreenName || specialGreenId;

    if (details != null) {
      var applyLinkTitle = details.applyLinkTitle
        ? details.applyLinkTitle
        : _("Apply");

      var applyLinkStyle = {};
      try {
        applyLinkStyle = details.applyLinkStyle
          ? JSON.parse(details.applyLinkStyle)
          : {};
      } catch (e) {
        console.error(
          'Failed to parse provided applyLinkStyle value as proper JSON.. use {"prop":"value"} notation'
        );
      }

      applyLink = details.applyLink;

      view = (
        <div>
          <h1 hidden={details.hideTitle == true}>{details.title}</h1>
          <div className="card">
            <div hidden={details.hideHeader == true} className="card-header">
              <div className="row">
                <div className="col-3">
                  <img className="mw-100 mh-100" src={details.stand.imageUrl} />
                </div>
                <div className="col-9">
                  <h5 className="card-title">{details.stand.title}</h5>
                  <div>
                    <div className="location">
                      {details.locationDisplay
                        ? details.locationDisplay
                        : details.location}
                    </div>
                    <div className="deadline">
                      {App.formatShortDate(details.deadline)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div
                className="job-content"
                dangerouslySetInnerHTML={{ __html: details.description }}
              ></div>
              {isFairActive && (
                <p className="text-center apply">
                  <a
                    href={applyLink}
                    target="_blank"
                    onClick={this.handleApply}
                    className="btn btn-lg btn-primary"
                    style={applyLinkStyle}
                  >
                    {applyLinkTitle}
                  </a>
                </p>
              )}
            </div>
          </div>
        </div>
      );
      if (specialGreenTheme) {
        view = (
          <div>
            <div className="rsprs__header">
              <div className="container rsprs__header_content">
                <div className="row">
                  <div className="col">
                    <h1 className="h4">
                      <strong>{details.title}</strong>
                    </h1>
                    <h2 className="h5">{details.stand.title}</h2>
                    <div className="mt-4">
                      <p className="my-0">
                        {details.locationDisplay
                          ? details.locationDisplay
                          : details.location}
                      </p>
                      <p className="my-0">
                        {App.formatShortDate(details.deadline)}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-auto rsprs__logo_container">
                    <div className="rsprs__logo">
                      <img src={details.stand.imageUrl} alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div
                className="job-content rsprs__job-content"
                dangerouslySetInnerHTML={{ __html: details.description }}
              ></div>
              {isFairActive && (
                <p className="text-center apply">
                  <a
                    href={applyLink}
                    target="_blank"
                    onClick={this.handleApply}
                    className="btn btn-lg btn-primary"
                    style={applyLinkStyle}
                  >
                    {applyLinkTitle}
                  </a>
                </p>
              )}
            </div>
          </div>
        );
      }
    }

    return (
      <div className="job-details">
        <Loading visible={details == null} description={_("Loading") + "..."} />
        {view}
      </div>
    );
  }
}

export default withRouter(Container.create(JobDetails));



// WEBPACK FOOTER //
// ./src/modules/components/jobdetails.js